<template>
  <div class="strategy-divider7-section">
    <divider
      :label="fields.field_one.value.divider"
      :is-bold="true"
    />
  </div>
</template>

<script>
import Divider from "/seu-frontend/components/section-fields/Divider";

export default {
  name: "StrategyDivider7Section",
  components: {Divider},
  props: {
    fields: {
      type: Object
    }
  }

}
</script>

